/* eslint-disable no-console */
import { CookieStorage } from 'cookie-storage';
import { initModal, toggleModal } from '../components/modal';
export const cookieStorage = new CookieStorage({
    path: '/',
});
export const alreadyOpened = () => {
    const emailPopupCookie = cookieStorage.getItem('ra-email-popup-opened');
    // We revalidate in case the cookie has already expired
    if (emailPopupCookie && emailPopupCookie === '1') {
        return true;
    }
    return false;
};
export const alredySubmitted = () => {
    const emailPopupCookie = cookieStorage.getItem('ra-email-popup-submitted');
    // We revalidate in case the cookie has already expired
    if (emailPopupCookie && emailPopupCookie === '1') {
        return true;
    }
    return false;
};
const onOpen = () => {
    const expires = new Date();
    const days = 30;
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    cookieStorage.setItem('ra-email-popup-opened', '1', {
        path: '/',
        expires,
    });
};
const onSubmit = () => {
    const expires = new Date();
    const days = 365 * 2; // 2 years
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    cookieStorage.setItem('ra-email-popup-submitted', '1', {
        path: '/',
        expires,
    });
};
// To debug open the console in your browser and type
// sessionStorage.setItem('debug:email-popup','1');
// then refresh the page
initModal('email-popup-modal', {
    onClose: () => {
        onOpen();
    },
});
window.addEventListener('ready-to-display-newsletter', () => {
    const debug = sessionStorage.getItem('debug:email-popup');
    if (debug) {
        if (alreadyOpened()) {
            console.info('Email Popup: Already Opened');
        }
        else {
            console.info('Email Popup: Firt Time Opened');
        }
        if (alredySubmitted()) {
            console.info('Email Popup: Already Submitted');
        }
        else {
            console.info('Email Popup: Not Submitted');
        }
    }
    if ((!alreadyOpened() && !alredySubmitted()) || debug) {
        // Open the modal
        toggleModal('email-popup-modal');
        // Add on submit event
        const submitForm = document.querySelector('.email-popup-block .newsletter__form form');
        if (submitForm) {
            submitForm.addEventListener('submit', () => {
                // Set the submitted cookie
                onSubmit();
            });
        }
    }
});
